module.exports = {
  courier: {
    id: 6,
    caption: 'Курьер',
    description: 'Услуги по доставке заказов потребителям',
    rates: [325, 236, 120],
  },
  driver: {
    id: 5,
    caption: 'Водитель-курьер',
    description: 'Услуги по доставке заказов потребителям с использованием автотранспорта',
    rates: [325, 236, 120],
  },
  cargo: {
    id: 2,
    caption: 'Грузчик',
    description: 'Услуги по погрузке-выгрузке товаров',
    rates: [277, 250, 181],
  },
  salesroom: {
    id: 11,
    caption: 'Работник торгового зала',
    description: 'Услуги по выкладке и размещению товара',
    rates: [269, 254, 201],
  },
  cook: {
    id: 15,
    caption: 'Повар',
    description: 'Услуги по изготовлению блюд',
    rates: [247, 223, 201],
  },
  baker: {
    id: 16,
    caption: 'Пекарь',
    description: 'Услуги по изготовлению хлебобулочных/кондитерских изделий',
    rates: null,
  },
  molder: {
    id: 12,
    caption: 'Формовщик',
    description: 'Услуги по заполнению форм для выпечки хлебо-булочных изделий, упаковке и маркировке готовой продукции',
    rates: null,
  },
  washer: {
    id: 10,
    caption: 'Мойщик',
    description: 'Услуги клининга и мытья посуды',
    rates: [190, 164, 150],
  },
  cleaner: {
    id: 7,
    caption: 'Уборщик',
    description: 'Оказание услуг по уборке внутри зала и прилегающей территории',
    rates: [190, 164, 150],
  },
  merch: {
    id: 3,
    caption: 'Мерчандайзер',
    description: 'Услуги мерчендайзинга',
    rates: [234, 200, 171],
  },
  waiter: {
    id: 8,
    caption: 'Официант',
    description: 'Услуги по обслуживанию посетителей заведения общественного питания',
    rates: [329, 294, 235],
  },
  barista: {
    id: 9,
    caption: 'Бариста',
    description: 'Услуги по приготовлению безалкогольных напитков',
    rates: [231, 211, 176],
  },
  promo: {
    id: 4,
    caption: 'Промоутер',
    description: 'Услуги по презентации товаров неограниченному кругу лиц (раздача сэмплов, дегустация, раздача листовок)',
    rates: null,
  },
  cash: {
    id: 1,
    caption: 'Кассир',
    description: 'Услуги по обслуживанию посетителей в кассовой и прикассовой зоне',
    rates: [230, 217, 201],
  },
  revisor: {
    id: 20,
    caption: 'Счётчик-ревизор',
    description: 'Услуги по пересчету и сканированию товаров',
    rates: null,
  },
  designer: {
    id: 21,
    caption: 'Дизайнер',
    description: 'Услуги по разработке графических материалов',
    rates: null,
  },
  copywriter: {
    id: 22,
    caption: 'Копирайтер',
    description: 'Услуги копирайтинга',
    rates: null,
  },
  marketologist: {
    id: 23,
    caption: 'Маркетолог',
    description: 'Услуги маркетинга',
    rates: null,
  },
  analyst: {
    id: 24,
    caption: 'Аналитик',
    description: 'Услуги по анализу данных',
    rates: null,
  },
  contentman: {
    id: 25,
    caption: 'Оператор БД',
    description: 'Услуги по внесению и редактированию данных',
    rates: null,
  },
  picker: {
    id: 26,
    caption: 'Комплектовщик',
    description: 'Услуги по комплектации заказов',
    rates: null,
  },
  order_picker: {
    id: 27,
    caption: 'Сборщик заказов',
    description: 'Услуги по сборке заказов',
    rates: null,
  },
  bike_courier: {
    id: 28,
    caption: 'Велокурьер',
    description: 'Услуги по доставке заказов потребителям с использованием велотранспорта',
    rates: null,
  },
  stockman: {
    id: 29,
    caption: 'Кладовщик',
    description: 'Услуги по распределению товара на складе',
    rates: null,
  },
  handyman: {
    id: 30,
    caption: 'Разнорабочий',
    description: 'Хозяйственные работы на кухне',
    rates: null,
  },
  procurer: {
    id: 31,
    caption: 'Корневщик',
    description: 'Услуги по очистке овощей',
    rates: null,
  },
  confectioner: {
    id: 32,
    caption: 'Кондитер',
    description: 'Услуги по производству кондитерских изделий',
    rates: null,
  },
  shop_assistant: {
    id: 33,
    caption: 'Продавец-консультант',
    description: 'Услуги по консультированию покупателей в торговом зале',
    rates: null,
  },
  barman: {
    id: 34,
    caption: 'Бармен',
    description: 'Услуги бармена (приготовление напитков)',
    rates: null,
  },
  scooter_courier: {
    id: 35,
    caption: 'Курьер на самокате',
    description: 'Услуги по доставке заказов потребителям с использованием самоката',
    rates: null,
  },
  sushi_chef: {
    id: 36,
    caption: 'Суши-повар',
    description: 'Услуги приготовления суши',
    rates: null,
  },
  security: {
    id: 37,
    caption: 'Охранник',
    description: 'Услуги охраны',
    rates: null,
  },
  auxiliary_worker: {
    id: 38,
    caption: 'Подсобный рабочий',
    description: 'Оказание услуг, не требующих специальной подготовки (выполнение подсобных работ)',
    rates: null,
  },
};
